import { render } from "./ExportRenderContainer.vue?vue&type=template&id=0025aac6&scoped=true&ts=true"
import script from "./ExportRenderContainer.vue?vue&type=script&lang=ts"
export * from "./ExportRenderContainer.vue?vue&type=script&lang=ts"

import "./ExportRenderContainer.vue?vue&type=style&index=0&id=0025aac6&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/apps/builder-legacy/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0025aac6"]])

export default __exports__